import { render, staticRenderFns } from "./bodyprint-measurements-table.vue?vue&type=template&id=7a4c7a39"
import script from "./bodyprint-measurements-table.vue?vue&type=script&lang=js"
export * from "./bodyprint-measurements-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports